import React from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import AdminMenu from "../../components/admin/adminMenu";
import EventChart from "../../components/admin/eventChart";
import BackendConnectionService from "../../ports/backend/backendConnectionService";
import LocalStorageService from "../../ports/localStorage/localStorageService";
import ResponseProcessorService from "../../ports/backend/ResponseProcessorService";

export default class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dnis: "Cargando...",
            passports: "Cargando..."
        }
    }

    componentDidMount() {
        const token = LocalStorageService.getUserToken();
        if (!token) {
            window.location.assign("/admin");
        }
        BackendConnectionService.getMetricCounters(token)
        .then(response => {
            this.setState({
                dnis: response.data.dnis || "0",
                passports: response.data.passports || "0"
            });
        })
        .catch(error => {
            console.error("Error fetching metric counters:", error);
            this.setState({ dnis: "Error", passports: "Error" });
            ResponseProcessorService.processError(error);
        });
    }

    render() {
        const { dnis, passports } = this.state;
        return(
            <div id="layout-wrapper">
                <Navbar />
                <AdminMenu />

                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-flex align-items-center justify-content-between">
                                        <h4 className="mb-0 font-size-18" style={{color: "#fff"}}>Panel de control</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 col-xl-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="media">
                                                <div className="media-body">
                                                    <h5 className="font-size-14">DNIs en el sistema</h5>
                                                </div>
                                                <div className="avatar-xs">
                                                    <span className="avatar-title rounded-circle bg-primary">
                                                        <i className="dripicons-user-id"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <h4 className="m-0 align-self-center">{dnis}</h4>
                                        </div>
                                    </div>
                                </div>
        
                                <div className="col-sm-6 col-xl-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="media">
                                                <div className="media-body">
                                                    <h5 className="font-size-14">Pasaportes en el sistema</h5>
                                                </div>
                                                <div className="avatar-xs">
                                                    <span className="avatar-title rounded-circle bg-primary">
                                                        <i className="dripicons-article"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <h4 className="m-0 align-self-center">{passports}</h4>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title mb-4">Eventos en los últimos 30 días</h4>
                                            <EventChart />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
        );
    }
}